import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>迷妹漫画</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              迷妹漫画提供海量免费漫画资源，涵盖日韩国漫全本免费在线看，支持下拉式滚动阅读，零花费畅享全本完结与连载漫画，是漫画迷的免费阅读乐园。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(1, 7).map(cat => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                <span>contact@mimei-comic.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                <span>官方QQ群：88888888</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line w-4 h-4 flex items-center justify-center text-foreground-400"></i>
                <span>微信公众号：迷妹漫画</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">&copy; 2026 迷妹漫画 mimei-comic.com 版权所有</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}